import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Kanban from './pages/Kanban';
import IAQualificacao from './pages/IAQualificacao';
import Corretores from './pages/Corretores';
import MeuPerfilCorretor from './pages/MeuPerfilCorretor';
import GestaoCorretores from './pages/GestaoCorretores';
import Diretoria from './pages/Diretoria';
import PerformanceComercial from './pages/PerformanceComercial';
import MDIExplain from './pages/MDIExplain';
import LeadIntakeCenter from './pages/LeadIntakeCenter';
import ActivationControl from './pages/ActivationControl';
import PublicCapturePortal from './pages/PublicCapturePortal';
import Empreendimentos from './pages/Empreendimentos';
import MercadosRegioes from './pages/MercadosRegioes';
import ConflitosComerciais from './pages/ConflitosComerciais';
import NovoLead from './pages/NovoLead';
import NovoCorretor from './pages/NovoCorretor';
import AlterarSenhaTemporaria from './pages/AlterarSenhaTemporaria';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kanban"
            element={
              <ProtectedRoute>
                <Kanban />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ia"
            element={
              <ProtectedRoute>
                <IAQualificacao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/corretores"
            element={
              <ProtectedRoute>
                <Corretores />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meu-perfil"
            element={
              <ProtectedRoute>
                <MeuPerfilCorretor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/alterar-senha"
            element={
              <ProtectedRoute>
                <AlterarSenhaTemporaria />
              </ProtectedRoute>
            }
          />

          <Route
            path="/novo-corretor"
            element={
              <ProtectedRoute>
                <NovoCorretor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/gestao-corretores"
            element={
              <ProtectedRoute>
                <GestaoCorretores />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diretoria"
            element={
              <ProtectedRoute>
                <Diretoria />
              </ProtectedRoute>
            }
          />

          <Route
            path="/performance-comercial"
            element={
              <ProtectedRoute>
                <PerformanceComercial />
              </ProtectedRoute>
            }
          />

          <Route
            path="/mdi-explain"
            element={
              <ProtectedRoute>
                <MDIExplain />
              </ProtectedRoute>
            }
          />

          <Route
            path="/lead-intake"
            element={
              <ProtectedRoute>
                <LeadIntakeCenter />
              </ProtectedRoute>
            }
          />

          <Route
            path="/activation-control"
            element={
              <ProtectedRoute>
                <ActivationControl />
              </ProtectedRoute>
            }
          />

          <Route
            path="/mercados-regioes"
            element={
              <ProtectedRoute>
                <MercadosRegioes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/captura/:slug"
            element={<PublicCapturePortal />}
          />
          <Route
            path="/empreendimentos"
            element={
              <ProtectedRoute>
                <Empreendimentos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/novo-lead"
            element={
              <ProtectedRoute>
                <NovoLead />
              </ProtectedRoute>
            }
          />
          <Route
            path="/conflitos"
            element={
              <ProtectedRoute>
                <ConflitosComerciais />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
